import { Link } from 'react-router-dom';
import { CreditDashboard } from '../../components/Billing/CreditDashboard.jsx';
import { InvoiceHistory } from '../../components/Billing/InvoiceHistory.jsx';
import { PlansPage } from '../../components/Billing/PlansPage.jsx';

export default function BillingPage() {
  return (
    <div className="min-h-screen bg-surface text-on-surface p-6 space-y-10">
      <div className="max-w-6xl mx-auto space-y-10">
        <div className="mb-4">
          <Link to="/chat" className="hidden md:inline-flex items-center gap-2 px-4 py-2 bg-surface-container-low hover:bg-surface-container-high rounded-lg font-medium transition-colors border border-outline-variant">
            <span>←</span> Voltar para o Chat
          </Link>
        </div>
        <PlansPage />
        <div className="space-y-6">
          <h2 className="text-2xl font-bold">Seus Créditos</h2>
          <CreditDashboard />
        </div>
        <div className="space-y-6">
          <h2 className="text-2xl font-bold">Faturas</h2>
          <InvoiceHistory />
        </div>
      </div>
    </div>
  );
}

